module.exports = __webpack_public_path__ + "814f084411b4130397d0d45019fd20f6.glb";